// Import solid icons (only icons explicitly used with variant="solid")

// Import light icons (for icons that need light variant)
import {
  faAngleLeft as faAngleLeftLight,
  faBullseye as faBullseyeLight,
  faCalendarXmark as faCalendarXmarkLight,
  faCircleExclamation as faCircleExclamationLight,
  faClipboard as faClipboardLight,
  faFile as faFileLight,
  faHeartCircleCheck as faHeartCircleCheckLight,
  faIdCard as faIdCardLight,
  faPlus as faPlusLight,
  faPrescriptionBottlePill as faPrescriptionBottlePillLight,
  faReceipt as faReceiptLight,
  faSquareCheck as faSquareCheckLight,
  faTriangleExclamation as faTriangleExclamationLight,
} from "@fortawesome/pro-light-svg-icons";

// Import regular icons (for icons that need regular variant)
import {
  faAddressBook as faAddressBookRegular,
  faAlignCenter as faAlignCenterRegular,
  faAlignLeft as faAlignLeftRegular,
  faAlignRight as faAlignRightRegular,
  faArrowDownAZ as faArrowDownAZRegular,
  faArrowDownLongToLine as faArrowDownLongToLineRegular,
  faArrowDown as faArrowDownRegular,
  faArrowDownRight as faArrowDownRightRegular,
  faArrowDownWideShort as faArrowDownWideShortRegular,
  faArrowLeft as faArrowLeftRegular,
  faArrowLeftToLine as faArrowLeftToLineRegular,
  faArrowRight as faArrowRightRegular,
  faArrowRightToLine as faArrowRightToLineRegular,
  faArrowsRotate as faArrowsRotateRegular,
  faArrowTurnDownLeft as faArrowTurnDownLeftRegular,
  faArrowTurnDown as faArrowTurnDownRegular,
  faArrowTurnUp as faArrowTurnUpRegular,
  faArrowUpLongToLine as faArrowUpLongToLineRegular,
  faArrowUp as faArrowUpRegular,
  faArrowUpRightFromSquare as faArrowUpRightFromSquareRegular,
  faArrowUpRight as faArrowUpRightRegular,
  faArrowUpShortWide as faArrowUpShortWideRegular,
  faAtom as faAtomRegular,
  faAt as faAtRegular,
  faBan as faBanRegular,
  faBarsFilter as faBarsFilterRegular,
  faBed as faBedRegular,
  faBell as faBellRegular,
  faBold as faBoldRegular,
  faBone as faBoneRegular,
  faBooks as faBooksRegular,
  faBracketsSquare as faBracketsSquareRegular,
  faBrain as faBrainRegular,
  faBroomWide as faBroomWideRegular,
  faBullseyeArrow as faBullseyeArrowRegular,
  faBullseye as faBullseyeRegular,
  faCalendarCheck as faCalendarCheckRegular,
  faCalendarDay as faCalendarDayRegular,
  faCalendarDays as faCalendarDaysRegular,
  faCalendarPlus as faCalendarPlusRegular,
  faCalendar as faCalendarRegular,
  faCalendarXmark as faCalendarXmarkRegular,
  faCapsules as faCapsulesRegular,
  faCaretDown as faCaretDownRegular,
  faCaretLeft as faCaretLeftRegular,
  faCaretRight as faCaretRightRegular,
  faCaretUp as faCaretUpRegular,
  faCartShopping as faCartShoppingRegular,
  faChartLine as faChartLineRegular,
  faCheckCircle as faCheckCircleRegular,
  faCheck as faCheckRegular,
  faChevronDown as faChevronDownRegular,
  faChevronLeft as faChevronLeftRegular,
  faChevronRight as faChevronRightRegular,
  faChevronUp as faChevronUpRegular,
  faCircleCheck as faCircleCheckRegular,
  faCircleDashed as faCircleDashedRegular,
  faCircleDot as faCircleDotRegular,
  faCircleExclamation as faCircleExclamationRegular,
  faCircleInfo as faCircleInfoRegular,
  faCircleQuestion as faCircleQuestionRegular,
  faCircle as faCircleRegular,
  faCircleUser as faCircleUserRegular,
  faClipboardList as faClipboardListRegular,
  faClipboard as faClipboardRegular,
  faClock as faClockRegular,
  faClockRotateLeft as faClockRotateLeftRegular,
  faClone as faCloneRegular,
  faColumns3 as faColumns3Regular,
  faCommand as faCommandRegular,
  faCommentMedical as faCommentMedicalRegular,
  faComment as faCommentRegular,
  faCommentSlash as faCommentSlashRegular,
  faComments as faCommentsRegular,
  faCopy as faCopyRegular,
  faCreditCard as faCreditCardRegular,
  faCube as faCubeRegular,
  faDna as faDnaRegular,
  faDoorClosed as faDoorClosedRegular,
  faDownload as faDownloadRegular,
  faDumbbell as faDumbbellRegular,
  faEllipsis as faEllipsisRegular,
  faEllipsisVertical as faEllipsisVerticalRegular,
  faEnvelope as faEnvelopeRegular,
  faEye as faEyeRegular,
  faEyeSlash as faEyeSlashRegular,
  faFaceSmile as faFaceSmileRegular,
  faFax as faFaxRegular,
  faFileArchive as faFileArchiveRegular,
  faFileAudio as faFileAudioRegular,
  faFileCirclePlus as faFileCirclePlusRegular,
  faFileCsv as faFileCsvRegular,
  faFileExcel as faFileExcelRegular,
  faFileImage as faFileImageRegular,
  faFileLines as faFileLinesRegular,
  faFileMedical as faFileMedicalRegular,
  faFilePdf as faFilePdfRegular,
  faFilePowerpoint as faFilePowerpointRegular,
  faFilePrescription as faFilePrescriptionRegular,
  faFile as faFileRegular,
  faFileVideo as faFileVideoRegular,
  faFileWord as faFileWordRegular,
  faFireFlameCurved as faFireFlameCurvedRegular,
  faFlag as faFlagRegular,
  faFlask as faFlaskRegular,
  faFlaskVial as faFlaskVialRegular,
  faFloppyDisk as faFloppyDiskRegular,
  faFolderMedical as faFolderMedicalRegular,
  faFont as faFontRegular,
  faGear as faGearRegular,
  faGripLinesVertical as faGripLinesVerticalRegular,
  faGripVertical as faGripVerticalRegular,
  faH1 as faH1Regular,
  faH2 as faH2Regular,
  faH3 as faH3Regular,
  faH4 as faH4Regular,
  faHashtag as faHashtagRegular,
  faHeartPulse as faHeartPulseRegular,
  faHouse as faHouseRegular,
  faIdCard as faIdCardRegular,
  faInbox as faInboxRegular,
  faIndent as faIndentRegular,
  faItalic as faItalicRegular,
  faJar as faJarRegular,
  faLayerGroup as faLayerGroupRegular,
  faLeaf as faLeafRegular,
  faLightbulb as faLightbulbRegular,
  faLink as faLinkRegular,
  faLinkSlash as faLinkSlashRegular,
  faListCheck as faListCheckRegular,
  faListOl as faListOlRegular,
  faList as faListRegular,
  faListUl as faListUlRegular,
  faLocationCrosshairs as faLocationCrosshairsRegular,
  faLocationDot as faLocationDotRegular,
  faLock as faLockRegular,
  faMagnifyingGlassMinus as faMagnifyingGlassMinusRegular,
  faMagnifyingGlassPlus as faMagnifyingGlassPlusRegular,
  faMagnifyingGlass as faMagnifyingGlassRegular,
  faMap as faMapRegular,
  faMask as faMaskRegular,
  faMemo as faMemoRegular,
  faMessageLines as faMessageLinesRegular,
  faMicrophone as faMicrophoneRegular,
  faMicrophoneSlash as faMicrophoneSlashRegular,
  faMobile as faMobileRegular,
  faMoneyCheckDollar as faMoneyCheckDollarRegular,
  faMonitorWaveform as faMonitorWaveformRegular,
  faMoonStars as faMoonStarsRegular,
  faMortarPestle as faMortarPestleRegular,
  faNoteMedical as faNoteMedicalRegular,
  faNote as faNoteRegular,
  faNoteSticky as faNoteStickyRegular,
  faOutdent as faOutdentRegular,
  faPalette as faPaletteRegular,
  faPaperclip as faPaperclipRegular,
  faPaperPlane as faPaperPlaneRegular,
  faPartyHorn as faPartyHornRegular,
  faPencil as faPencilRegular,
  faPenLine as faPenLineRegular,
  faPen as faPenRegular,
  faPenToSquare as faPenToSquareRegular,
  faPeopleGroup as faPeopleGroupRegular,
  faPerson as faPersonRegular,
  faPhone as faPhoneRegular,
  faPills as faPillsRegular,
  faPlus as faPlusRegular,
  faPrescriptionBottleMedical as faPrescriptionBottleMedicalRegular,
  faPrescriptionBottlePill as faPrescriptionBottlePillRegular,
  faPrescription as faPrescriptionRegular,
  faPrint as faPrintRegular,
  faRectangleVertical as faRectangleVerticalRegular,
  faReply as faReplyRegular,
  faRightFromBracket as faRightFromBracketRegular,
  faRobot as faRobotRegular,
  faRotateLeft as faRotateLeftRegular,
  faRotateRight as faRotateRightRegular,
  faRulerHorizontal as faRulerHorizontalRegular,
  faSalad as faSaladRegular,
  faSeedling as faSeedlingRegular,
  faSliders as faSlidersRegular,
  faSparkles as faSparklesRegular,
  faSpinner as faSpinnerRegular,
  faSpinnerThird as faSpinnerThirdRegular,
  faSquareCheck as faSquareCheckRegular,
  faSquareDown as faSquareDownRegular,
  faSquarePollHorizontal as faSquarePollHorizontalRegular,
  faSquare as faSquareRegular,
  faSquareUp as faSquareUpRegular,
  faStarHalfStroke as faStarHalfStrokeRegular,
  faStethoscope as faStethoscopeRegular,
  faStomach as faStomachRegular,
  faStop as faStopRegular,
  faTags as faTagsRegular,
  faTasks as faTasksRegular,
  faTextSlash as faTextSlashRegular,
  faThumbsDown as faThumbsDownRegular,
  faThumbsUp as faThumbsUpRegular,
  faThumbtack as faThumbtackRegular,
  faToggleOn as faToggleOnRegular,
  faTrash as faTrashRegular,
  faTriangleExclamation as faTriangleExclamationRegular,
  faTriangle as faTriangleRegular,
  faUnderline as faUnderlineRegular,
  faUpload as faUploadRegular,
  faUserDoctor as faUserDoctorRegular,
  faUserGear as faUserGearRegular,
  faUserPen as faUserPenRegular,
  faUser as faUserRegular,
  faUsers as faUsersRegular,
  faUserTie as faUserTieRegular,
  faVial as faVialRegular,
  faVideo as faVideoRegular,
  faXmark as faXmarkRegular,
  faXRay as faXRayRegular,
} from "@fortawesome/pro-regular-svg-icons";
import {
  faAngleRight,
  faArchive,
  faAt,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faCaretUp,
  faChartLine,
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faChevronDown,
  faChevronLeft,
  faChevronUp,
  faCircle,
  faCircleCheck,
  faCircleSmall,
  faComments,
  faCopy,
  faEllipsis,
  faEllipsisVertical,
  faEnvelopeOpenText,
  faFlag,
  faFloppyDisk,
  faLeaf,
  faMagnifyingGlass,
  faNote,
  faPause,
  faPlay,
  faPlus,
  faReply,
  faRotateRight,
  faSpinner,
  faSquare,
  faThumbsDown,
  faThumbsUp,
  faThumbtack,
  faTriangleExclamation,
  faUser,
  faXmark,
} from "@fortawesome/pro-solid-svg-icons";

/**
 * Icon registry with const assertion for full type inference.
 * Each icon is registered under its variant (solid, regular, light).
 */
export const iconRegistry = {
  solid: {
    "angle-right": faAngleRight,
    archive: faArchive,
    at: faAt,
    "caret-down": faCaretDown,
    "caret-left": faCaretLeft,
    "caret-right": faCaretRight,
    "caret-up": faCaretUp,
    "chart-line": faChartLine,
    check: faCheck,
    "check-circle": faCheckCircle,
    "check-double": faCheckDouble,
    "chevron-down": faChevronDown,
    "chevron-left": faChevronLeft,
    "chevron-up": faChevronUp,
    circle: faCircle,
    "circle-check": faCircleCheck,
    "circle-small": faCircleSmall,
    close: faXmark,
    comments: faComments,
    copy: faCopy,
    "ellipsis-h": faEllipsis,
    "ellipsis-v": faEllipsisVertical,
    "envelope-open-text": faEnvelopeOpenText,
    flag: faFlag,
    leaf: faLeaf,
    note: faNote,
    pause: faPause,
    play: faPlay,
    plus: faPlus,
    redo: faRotateRight,
    reply: faReply,
    save: faFloppyDisk,
    search: faMagnifyingGlass,
    spinner: faSpinner,
    square: faSquare,
    "thumbs-down": faThumbsDown,
    "thumbs-up": faThumbsUp,
    thumbtack: faThumbtack,
    "triangle-exclamation": faTriangleExclamation,
    user: faUser,
  },
  regular: {
    "address-book": faAddressBookRegular,
    "align-center": faAlignCenterRegular,
    "align-left": faAlignLeftRegular,
    "align-right": faAlignRightRegular,
    "arrow-down": faArrowDownRegular,
    "arrow-down-a-z": faArrowDownAZRegular,
    "arrow-down-long-to-line": faArrowDownLongToLineRegular,
    "arrow-down-right": faArrowDownRightRegular,
    "arrow-left": faArrowLeftRegular,
    "arrow-left-to-line": faArrowLeftToLineRegular,
    "arrow-right": faArrowRightRegular,
    "arrow-right-to-line": faArrowRightToLineRegular,
    "arrow-up-right": faArrowUpRightRegular,
    "arrow-turn-down": faArrowTurnDownRegular,
    "arrow-turn-down-left": faArrowTurnDownLeftRegular,
    "arrow-turn-up": faArrowTurnUpRegular,
    "arrow-up": faArrowUpRegular,
    "arrow-up-long-to-line": faArrowUpLongToLineRegular,
    "arrows-rotate": faArrowsRotateRegular,
    at: faAtRegular,
    atom: faAtomRegular,
    ban: faBanRegular,
    "bars-filter": faBarsFilterRegular,
    bed: faBedRegular,
    bell: faBellRegular,
    bold: faBoldRegular,
    bone: faBoneRegular,
    books: faBooksRegular,
    "brackets-square": faBracketsSquareRegular,
    brain: faBrainRegular,
    "broom-wide": faBroomWideRegular,
    bullseye: faBullseyeRegular,
    "bullseye-arrow": faBullseyeArrowRegular,
    calendar: faCalendarRegular,
    "calendar-check": faCalendarCheckRegular,
    "calendar-day": faCalendarDayRegular,
    "calendar-days": faCalendarDaysRegular,
    "calendar-plus": faCalendarPlusRegular,
    "calendar-xmark": faCalendarXmarkRegular,
    capsules: faCapsulesRegular,
    "caret-down": faCaretDownRegular,
    "caret-left": faCaretLeftRegular,
    "caret-right": faCaretRightRegular,
    "caret-up": faCaretUpRegular,
    "chart-line": faChartLineRegular,
    check: faCheckRegular,
    "check-circle": faCheckCircleRegular,
    "chevron-down": faChevronDownRegular,
    "chevron-left": faChevronLeftRegular,
    "chevron-right": faChevronRightRegular,
    "chevron-up": faChevronUpRegular,
    circle: faCircleRegular,
    "circle-check": faCircleCheckRegular,
    "circle-dashed": faCircleDashedRegular,
    "circle-dot": faCircleDotRegular,
    "circle-exclamation": faCircleExclamationRegular,
    "circle-info": faCircleInfoRegular,
    "circle-question": faCircleQuestionRegular,
    clipboard: faClipboardRegular,
    "clipboard-list": faClipboardListRegular,
    clock: faClockRegular,
    clone: faCloneRegular,
    close: faXmarkRegular,
    "columns-3": faColumns3Regular,
    command: faCommandRegular,
    comment: faCommentRegular,
    "comment-medical": faCommentMedicalRegular,
    comments: faCommentsRegular,
    "comments-slash": faCommentSlashRegular,
    copy: faCopyRegular,
    "credit-card": faCreditCardRegular,
    cube: faCubeRegular,
    dedent: faOutdentRegular,
    dna: faDnaRegular,
    "door-closed": faDoorClosedRegular,
    download: faDownloadRegular,
    dumbbell: faDumbbellRegular,
    "ellipsis-h": faEllipsisRegular,
    "ellipsis-v": faEllipsisVerticalRegular,
    envelope: faEnvelopeRegular,
    "exclamation-circle": faCircleExclamationRegular,
    "exclamation-triangle": faTriangleExclamationRegular,
    "external-link": faArrowUpRightFromSquareRegular,
    "external-link-alt": faArrowUpRightFromSquareRegular,
    eye: faEyeRegular,
    "eye-slash": faEyeSlashRegular,
    "face-smile": faFaceSmileRegular,
    fax: faFaxRegular,
    file: faFileRegular,
    "file-alt": faFileLinesRegular,
    "file-archive": faFileArchiveRegular,
    "file-audio": faFileAudioRegular,
    "file-circle-plus": faFileCirclePlusRegular,
    "file-csv": faFileCsvRegular,
    "file-excel": faFileExcelRegular,
    "file-image": faFileImageRegular,
    "file-lines": faFileLinesRegular,
    "file-medical": faFileMedicalRegular,
    "file-pdf": faFilePdfRegular,
    "file-powerpoint": faFilePowerpointRegular,
    "file-prescription": faFilePrescriptionRegular,
    "file-text": faFileLinesRegular,
    "file-video": faFileVideoRegular,
    "file-word": faFileWordRegular,
    "fire-flame-curved": faFireFlameCurvedRegular,
    flag: faFlagRegular,
    flask: faFlaskRegular,
    "flask-vial": faFlaskVialRegular,
    "folder-medical": faFolderMedicalRegular,
    font: faFontRegular,
    gear: faGearRegular,
    "grip-lines-vertical": faGripLinesVerticalRegular,
    "grip-vertical": faGripVerticalRegular,
    h1: faH1Regular,
    h2: faH2Regular,
    h3: faH3Regular,
    h4: faH4Regular,
    hashtag: faHashtagRegular,
    "heart-pulse": faHeartPulseRegular,
    history: faClockRotateLeftRegular,
    "horizontal-rule": faRulerHorizontalRegular,
    house: faHouseRegular,
    "id-card": faIdCardRegular,
    inbox: faInboxRegular,
    indent: faIndentRegular,
    "info-circle": faCircleInfoRegular,
    italic: faItalicRegular,
    jar: faJarRegular,
    "layer-group": faLayerGroupRegular,
    leaf: faLeafRegular,
    lightbulb: faLightbulbRegular,
    link: faLinkRegular,
    list: faListRegular,
    "list-check": faListCheckRegular,
    "location-crosshairs": faLocationCrosshairsRegular,
    "location-dot": faLocationDotRegular,
    "list-ol": faListOlRegular,
    "list-ul": faListUlRegular,
    lock: faLockRegular,
    map: faMapRegular,
    mask: faMaskRegular,
    memo: faMemoRegular,
    "message-lines": faMessageLinesRegular,
    microphone: faMicrophoneRegular,
    "microphone-slash": faMicrophoneSlashRegular,
    mobile: faMobileRegular,
    "money-check-alt": faMoneyCheckDollarRegular,
    "monitor-waveform": faMonitorWaveformRegular,
    "moon-stars": faMoonStarsRegular,
    "mortar-pestle": faMortarPestleRegular,
    note: faNoteRegular,
    "note-medical": faNoteMedicalRegular,
    "note-sticky": faNoteStickyRegular,
    "paper-plane": faPaperPlaneRegular,
    paperclip: faPaperclipRegular,
    palette: faPaletteRegular,
    "party-horn": faPartyHornRegular,
    pen: faPenRegular,
    "pen-line": faPenLineRegular,
    "pen-to-square": faPenToSquareRegular,
    pencil: faPencilRegular,
    "people-group": faPeopleGroupRegular,
    person: faPersonRegular,
    phone: faPhoneRegular,
    pills: faPillsRegular,
    plus: faPlusRegular,
    prescription: faPrescriptionRegular,
    "prescription-bottle-medical": faPrescriptionBottleMedicalRegular,
    "prescription-bottle-pill": faPrescriptionBottlePillRegular,
    print: faPrintRegular,
    "question-circle": faCircleQuestionRegular,
    "rectangle-vertical": faRectangleVerticalRegular,
    redo: faRotateRightRegular,
    reply: faReplyRegular,
    robot: faRobotRegular,
    "rotate-right": faRotateRightRegular,
    salad: faSaladRegular,
    save: faFloppyDiskRegular,
    search: faMagnifyingGlassRegular,
    "magnifying-glass-plus": faMagnifyingGlassPlusRegular,
    "magnifying-glass-minus": faMagnifyingGlassMinusRegular,
    seedling: faSeedlingRegular,
    "shopping-cart": faCartShoppingRegular,
    "sign-out": faRightFromBracketRegular,
    sliders: faSlidersRegular,
    "sort-amount-down-alt": faArrowDownWideShortRegular,
    "sort-amount-up": faArrowUpShortWideRegular,
    sparkles: faSparklesRegular,
    spinner: faSpinnerRegular,
    "spinner-third": faSpinnerThirdRegular,
    square: faSquareRegular,
    "square-check": faSquareCheckRegular,
    "square-down": faSquareDownRegular,
    "square-poll-horizontal": faSquarePollHorizontalRegular,
    "square-up": faSquareUpRegular,
    "star-half-stroke": faStarHalfStrokeRegular,
    stethoscope: faStethoscopeRegular,
    stomach: faStomachRegular,
    stop: faStopRegular,
    tags: faTagsRegular,
    tasks: faTasksRegular,
    "text-slash": faTextSlashRegular,
    "thumbs-down": faThumbsDownRegular,
    "thumbs-up": faThumbsUpRegular,
    thumbtack: faThumbtackRegular,
    times: faXmarkRegular,
    triangle: faTriangleRegular,
    "toggle-on": faToggleOnRegular,
    trash: faTrashRegular,
    "triangle-exclamation": faTriangleExclamationRegular,
    underline: faUnderlineRegular,
    undo: faRotateLeftRegular,
    unlink: faLinkSlashRegular,
    upload: faUploadRegular,
    user: faUserRegular,
    "circle-user": faCircleUserRegular,
    "user-doctor": faUserDoctorRegular,
    "user-gear": faUserGearRegular,
    "user-pen": faUserPenRegular,
    "user-tie": faUserTieRegular,
    users: faUsersRegular,
    vial: faVialRegular,
    video: faVideoRegular,
    warning: faTriangleExclamationRegular,
    "x-ray": faXRayRegular,
    xmark: faXmarkRegular,
  },
  light: {
    "angle-left": faAngleLeftLight,
    bullseye: faBullseyeLight,
    "calendar-xmark": faCalendarXmarkLight,
    "circle-exclamation": faCircleExclamationLight,
    clipboard: faClipboardLight,
    "exclamation-circle": faCircleExclamationLight,
    file: faFileLight,
    "heart-circle-check": faHeartCircleCheckLight,
    "id-card": faIdCardLight,
    plus: faPlusLight,
    "prescription-bottle-pill": faPrescriptionBottlePillLight,
    receipt: faReceiptLight,
    "square-check": faSquareCheckLight,
    "triangle-exclamation": faTriangleExclamationLight,
  },
} as const;

// Derive types from the registry
export type IconRegistry = typeof iconRegistry;
export type Variant = keyof IconRegistry;
export type IconName<V extends Variant> = keyof IconRegistry[V];

// Union of all icon names across all variants (for loose typing if needed)
export type AnyIconName = IconName<"solid"> | IconName<"regular"> | IconName<"light">;

/**
 * Retrieves an icon definition from the registry with full type safety.
 * TypeScript will error if you use an icon name that doesn't exist in the specified variant.
 *
 * @example
 * // Using default 'regular' variant
 * const icon = getIcon('house'); // TypeScript knows this returns IconDefinition
 *
 * // Using explicit variant
 * const solidIcon = getIcon('check', 'solid');
 *
 * // TypeScript error: 'nonexistent' doesn't exist in 'regular'
 * const bad = getIcon('nonexistent');
 */
export function getIcon<N extends IconName<"regular">>(name: N): IconRegistry["regular"][N];
export function getIcon<V extends Variant, N extends IconName<V>>(
  name: N,
  variant: V,
): IconRegistry[V][N];
export function getIcon(name: string, variant: Variant = "regular") {
  return iconRegistry[variant][name as keyof (typeof iconRegistry)[typeof variant]];
}
